import React, { useCallback, useMemo } from "react";
import { TranslationKey } from "./translationKeys";

interface I18NContextType {
  language: string;
  getTranslation: (
    key: TranslationKey | string,
    replacements?: Record<string, string | number>,
  ) => string;
}

export interface I18NContextProviderType {
  language: string;
  children: React.ReactNode;
  loadingComponent?: React.ReactNode;
}

export const I18nContext = React.createContext<I18NContextType>(
  {} as I18NContextType,
);

export const I18nContextProvider: React.FC<I18NContextProviderType> = ({
  children,
  language,
  loadingComponent,
}) => {
  void loadingComponent;

  /** Remote map from useTranslationsQuery is disabled for now. */
  const getTranslation = useCallback(
    (
      translationKey: TranslationKey | string,
      replacements?: Record<string, string | number>,
    ) => {
      void replacements;
      return String(translationKey);
    },
    [],
  );

  const contextValue = useMemo(
    () => ({ getTranslation, language }),
    [getTranslation, language],
  );

  return (
    <I18nContext.Provider value={contextValue}>{children}</I18nContext.Provider>
  );
};
